import React, { useState, useEffect, useRef } from "react";

import RequestHandler from "util/RequestHandler";
import { ColumnHelper } from "util/TableHelper";

import DbsInvoiceTableFilter from "../Filters/DbsInvoiceTableFilter";
import DbsInvoiceAddForm from "../Forms/DbsInvoiceAddForm";
import DbsInvoiceUpdateForm from "../Forms/DbsInvoiceUpdateForm";
import DbsInvoiceSentWarning from "./DbsInvoiceSentWarning";
import moment from "moment";
import ErpDbsInvoiceTableFilter from "../Filters/ErpDbsInvoiceTableFilter";
import DbsInvoiceErpNotAddedSummary from "./DbsInvoiceErpNotAddedSummary";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  Tooltip,
  Modal,
  notification,
  Tabs,
  Select,
  DatePicker,
} from "antd";
import {
  BarsOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SendOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { odata } from "../Filters/Helper";
import CurrencyFormat from "react-currency-format";
import DbsDealerSummary from "./DbsDealerSummary";
import ErpDbsInvoiceUpdateForm from "../Forms/ErpDbsInvoiceUpdateForm";
import ErpDbsMultipleInvoiceUpdateForm from "../Forms/ErpDbsMultipleInvoiceUpdateForm";
import ReactTags from "react-autocomplete-tag";

const DbsInvoice = () => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [addInvoiceVisibility, setAddInvoiceVisibility] = useState(false);
  const [updateInvoiceVisibility, setUpdateInvoiceVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [sendInvoiceLoading, setSendInvoiceLoading] = useState(false);
  const [order, setOrder] = useState("");
  const [sendInvoiceWarningModal, setSendInvoiceWarningModal] = useState({
    visible: false,
  });
  const [isUseErpDbsInvoice, setIsUseErpDbsInvoice] = useState(false);
  const [tabKeyValue, setTabKeyValue] = useState("0");
  const prevActiveTabKeyRef = useRef("");
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 100,
    current: 1,
    filter: "",
    activeTab: "0",
  });
  const [
    dbsInvoiceErpNotAddedSummaryModalVisible,
    setDbsInvoiceErpNotAddedSummaryModalVisible,
  ] = useState(false);

  const [erpDbsInvoiceModalData, setErpDbsInvoiceModalData] = useState([]);
  const [totalInvoiceCount, setTotalInvoiceCount] = useState(0);
  const [invoiceTotalAmount, setInvoiceTotalAmount] = useState(0.0);
  const [visibleDbsDealerSummaryModal, setVisibleDbsDealerSummaryModal] =
    useState(false);
  const [getInvoicesFromErpButtonDisable, setGetInvoicesFromErpButtonDisable] =
    useState(false);
  const [getErpInvoiceFeatureVisible, setGetErpInvoiceFeatureVisible] =
    useState(false);
  const [updateErpInvoiceVisibility, setUpdateErpInvoiceVisibility] =
    useState(false);

  const [
    updateMultipleErpInvoiceVisibility,
    setUpdateMultipleErpInvoiceVisibility,
  ] = useState(false);

  const [tags, setTags] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isUsePartialDbsInvoice, setIsUsePartialDbsInvoice] = useState(false);

  useEffect(() => {
    getTableData();
  }, [order, tableDataQueryOptions]);

  useEffect(() => {
    isUseForErp();
    getTenantParameter();
    getBanks();
  }, []);

  useEffect(() => {
    prevActiveTabKeyRef.current = tabKeyValue;
  }, [tabKeyValue]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });
    setSelectedRowKeys([]);

    let query = "";
    const { skip, take, filter } = tableDataQueryOptions;

    const conditions = [];
    if (filter && prevActiveTabKeyRef.current === tabKeyValue) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }

    if (tabKeyValue === "0") {
      RequestHandler.get(
        `/DbsInvoice?$count=true${query}${order}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        if (Array.isArray(response.value)) {
          setTableData({
            data: response.value,
            total: response["@odata.count"],
            loading: false,
          });
        }
      });

      RequestHandler.get(`/DbsInvoice?$count=true${query}&$select=amount`).then(
        (response) => {
          if (Array.isArray(response.value)) {
            setInvoiceTotalAmount(calculateTotal(response.value));
            setTotalInvoiceCount(response["@odata.count"]);
          }
        }
      );
    } else if (tabKeyValue === "1") {
      RequestHandler.get(
        `/ErpDbsInvoice?$count=true${query}${order}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        if (Array.isArray(response.value)) {
          setTableData({
            data: response.value,
            total: response["@odata.count"],
            loading: false,
          });
        }
      });

      RequestHandler.get(`/ErpDbsInvoice?$count=true${query}`).then(
        (response) => {
          if (Array.isArray(response.value)) {
            setInvoiceTotalAmount(calculateTotal(response.value));
            setTotalInvoiceCount(response["@odata.count"]);
          }
        }
      );
    } else if (tabKeyValue === "2") {
      RequestHandler.get(
        `/DbsPartialInvoice?$count=true${query}${order}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        if (Array.isArray(response.value)) {
          setTableData({
            data: response.value,
            total: response["@odata.count"],
            loading: false,
          });
        }
      });

      RequestHandler.get(
        `/DbsPartialInvoice?$count=true${query}&$select=amount`
      ).then((response) => {
        if (Array.isArray(response.value)) {
          setInvoiceTotalAmount(calculateTotal(response.value));
          setTotalInvoiceCount(response["@odata.count"]);
        }
      });
    }
  };

  function calculateTotal(list) {
    const total = list.reduce((total, item) => total + item.amount, 0);
    return total.toFixed(2);
  }

  const paging = (p, filters, sorter) => {
    let order = "";
    if (sorter.columnKey && sorter.order) {
      order =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(order);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const handleOnClickUpdate = (record) => {
    RequestHandler.get(`/DbsInvoice/GetById/${record.id}`).then((response) => {
      if (response) {
        setUpdateFormData(response);
        setUpdateInvoiceVisibility(true);
      }
    });
  };

  const handleOnClickErpDbsInvoiceUpdate = (record) => {
    if (selectedRowKeys.length > 1) {
      setUpdateFormData({ ids: selectedRowKeys });
      setUpdateMultipleErpInvoiceVisibility(true);
    } else {
      RequestHandler.get(`/ErpDbsInvoice/GetById/${record.id}`).then(
        (response) => {
          if (response) {
            setUpdateFormData(response);
            setUpdateErpInvoiceVisibility(true);
          }
        }
      );
    }
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/DbsInvoice/${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const onAddInvoiceSuccess = () => {
    getTableData();
    setAddInvoiceVisibility(false);
  };

  const onUpdateInvoiceSuccess = () => {
    getTableData();
    setUpdateInvoiceVisibility(false);
    setUpdateErpInvoiceVisibility(false);
    setUpdateMultipleErpInvoiceVisibility(false);
  };

  const onTableSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };

  const sendInvoices = (invoiceIds) => {
    if (invoiceIds && invoiceIds.length <= 0) {
      setSendInvoiceLoading(false);
      getTableData();
      return;
    }
    RequestHandler.post(
      "/DbsBank/UpdateInvoicesSendingStatus",
      {
        invoiceIds: invoiceIds,
      },
      false
    ).then((response) => {
      if (response) {
        RequestHandler.post(
          "/DbsBank/Add",
          { invoiceIds: invoiceIds },
          false
        ).then((response) => {
          setSendInvoiceLoading(false);
          setTimeout(() => {
            getTableData();
          }, 2000);
        });
      }
    });
  };

  const onFinishSendInvoiceWarning = (isSent) => {
    setSendInvoiceWarningModal({ visible: false });
    if (isSent) {
      setTimeout(() => {
        getTableData();
      }, 2000);
    } else {
      sendInvoices(sendInvoiceWarningModal.data?.upToDateInvoiceIds);
    }
  };

  const onConfirmSendInvoice = async () => {
    setSendInvoiceLoading(true);
    const checkInvoicesResult = await RequestHandler.post(
      "/DbsBank/CheckInvoiceDealerIsUpToDate",
      { invoiceIds: selectedRowKeys },
      false
    );

    if (checkInvoicesResult.success) {
      const checkWhetherInvoicesResult = await RequestHandler.post(
        "/DbsInvoice/CheckWhetherInvoicesWillBeSent",
        { invoiceIds: selectedRowKeys },
        false
      );

      if (checkWhetherInvoicesResult.success) {
        sendInvoices(checkWhetherInvoicesResult.data);
        openNotificationCheckWithIcon("success");
      } else {
        checkInvoiceErrorNotification(
          "error",
          checkWhetherInvoicesResult.message
        );
        setSendInvoiceLoading(false);
      }
    } else {
      setSendInvoiceLoading(false);

      if (checkInvoicesResult?.data?.dealerHasQueedUpInvoices === true) {
        checkInvoiceErrorNotification(
          "warning",
          "Seçilen faturaların bayileri içerisinde ilgili bayilere ait, sıraya alınmış bankaya gönderilecek faturalar bulunmaktadır. İlgili faturalar gönderildikten sonra, fatura gönderme işlemi yapabilirsiniz."
        );
      } else {
        setSendInvoiceWarningModal({
          visible: true,
          data: checkInvoicesResult.data,
        });
      }
    }
  };

  const onConfirmErpDbsInvoice = () => {
    setSendInvoiceLoading(true);
    if (selectedBankId === null || selectedBankId === "") {
      setSendInvoiceLoading(false);
      notification.error({
        message: "Lütfen faturaların oluşturulacağı Banka'yı seçiniz.",
        duration: 3,
      });
      return;
    }
    RequestHandler.post(
      "/ErpDbsInvoice",
      {
        bankId: selectedBankId,
        ErpDbsInvoiceIds: selectedRowKeys,
      },
      false
    ).then((response) => {
      if (response.value && response.value.length > 0) {
        setErpDbsInvoiceModalData(response.value);
        setDbsInvoiceErpNotAddedSummaryModalVisible(true);
        setSendInvoiceLoading(false);
      } else {
        notification.success({
          message: `${selectedRowKeys.length} adet fatura eklendi.`,
          duration: 5,
        });
        setSendInvoiceLoading(false);
        getTableData();
      }
    });
  };

  const onConfirmDeleteErpDbsInvoices = () => {
    setSendInvoiceLoading(true);
    RequestHandler.delete(
      "/ErpDbsInvoice",
      {
        ErpDbsInvoiceIds: selectedRowKeys,
      },
      true,
      { rawResponse: true }
    ).then((response) => {
      setSendInvoiceLoading(false);
      getTableData();
    });
  };

  const onConfirmDeleteDbsInvoices = () => {
    setSendInvoiceLoading(true);
    RequestHandler.delete(
      "/DbsInvoice/DeleteMultipleInvoice",
      {
        invoiceIds: selectedRowKeys,
      },
      true,
      { rawResponse: true }
    ).then((response) => {
      setSendInvoiceLoading(false);
      getTableData();
    });
  };

  const checkInvoiceErrorNotification = (type, message) => {
    notification[type]({
      message: "HATA",
      description: message,
      duration: 10,
    });
  };

  const openNotificationCheckWithIcon = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description:
        "Fatura gönderme talebiniz başarıyla alınmıştır.Bu işlem bir kaç dakika sürebilir.Faturalarının durumunu bu ekrandan takip edebilirsiniz.",
      duration: 10,
    });
  };

  const openNotificationWithIcon = (type, description) => {
    notification[type]({
      message: "Uyarı",
      description: description,
    });
  };

  const openNotificationGetInvoiceFromErpWithIcon = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description:
        "Faturaları Erp'den çekilme talebiniz başarıyla alınmıştır.Bu işlem bir kaç dakika sürebilir.Faturaların durumunu bu ekrandan takip edebilirsiniz.",
      duration: 10,
    });
  };

  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      width: 150,
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Bayi Adı",
      dataIndex: "dbsDealerName",
    },
    {
      title: "Fatura Tarihi",
      dataIndex: "invoiceDate",
      sorter: true,
      key: "invoiceDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Vade Tarihi",
      dataIndex: "dueDate",
      sorter: true,
      key: "dueDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Fatura Durumu",
      dataIndex: "status",
    },
    {
      title: "Fatura Numarası",
      dataIndex: "invoiceNumber",
    },
    {
      title: "Fatura Tutarı",
      dataIndex: "amount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      dataIndex: "currencyCode",
    },
    {
      title: "Açıklama",
      dataIndex: "description",
    },
    {
      title: "Uyarı",
      dataIndex: "isHaveWarning",
      align: "center",
      render: (data, row) => {
        return data ? (
          <Tooltip title={row.warningMessage}>
            <WarningOutlined style={{ color: "orange", fontSize: "130%" }} />
          </Tooltip>
        ) : undefined;
      },
    },
    {
      title: "Gönderilme Durumu",
      dataIndex: "isSending",
      align: "center",
      render: (data, row) => {
        return row.isSending ? (
          <p>Fatura bankaya gönderiliyor.</p>
        ) : row.queuedUp ? (
          <p>Fatura gönderilme sırasına alındı.</p>
        ) : (
          <p></p>
        );
      },
    },
    {
      title: "Bayi Notu",
      dataIndex: "dealerDescription",
      align: "center",
      render: (data, row) => {
        return data !== null ? (
          <Tooltip title={data}>
            <WarningOutlined style={{ color: "purple", fontSize: "130%" }} />
          </Tooltip>
        ) : undefined;
      },
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        row.isSending || row.queuedUp ? (
          <a
            onClick={() => {
              openNotificationWithIcon(
                "warning",
                "Bankaya gönderilen faturalar güncellenemez."
              );
            }}
            style={{ color: "orange", fontSize: "130%" }}
          >
            <EditOutlined />
          </a>
        ) : (
          <a onClick={() => handleOnClickUpdate(row)}>
            <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
          </a>
        ),
    },
    {
      title: "Sil",
      dataIndex: "id",
      align: "center",
      render: (data, record) =>
        record.isSending ? (
          <a
            onClick={() => {
              openNotificationWithIcon(
                "warning",
                "Bankaya gönderilen faturalar silinemez."
              );
            }}
            style={{ color: "red", fontSize: "130%" }}
          >
            <DeleteOutlined />
          </a>
        ) : (
          <Popconfirm
            title="Silmek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleOnClickDelete(data)}
          >
            <a>
              <DeleteOutlined style={{ color: "red", fontSize: "130%" }} />
            </a>
          </Popconfirm>
        ),
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: onTableSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.isSending || record.queuedUp, // isSending true ise seçimi devre dışı bırak
    }),
  };

  const erpDbsInvoiceColumns = [
    {
      title: "Bayi Adı",
      dataIndex: "dbsDealerName",
    },
    {
      title: "Bayi Kodu",
      dataIndex: "dealerCode",
    },
    {
      title: "Fatura Tarihi",
      dataIndex: "invoiceDate",
      sorter: true,
      key: "invoiceDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Vade Tarihi",
      dataIndex: "dueDate",
      sorter: true,
      key: "dueDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Fatura Numarası",
      dataIndex: "invoiceNumber",
    },
    {
      title: "Fatura Tutarı",
      dataIndex: "amount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      dataIndex: "currencyCode",
    },
    {
      title: "Şube Kodu",
      dataIndex: "branchCode",
    },
    {
      title: "Açıklama",
      dataIndex: "description",
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) => (
        <a onClick={() => handleOnClickErpDbsInvoiceUpdate(row)}>
          <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
        </a>
      ),
    },
  ];

  const isUseForErp = () => {
    RequestHandler.get("/TenantErpProgram/GetByTenant").then((response) => {
      if (response) {
        setIsUseErpDbsInvoice(response.isUseDbsInvoice);
        setGetErpInvoiceFeatureVisible(response.isUseDbsInvoiceV2);
      }
    });
  };

  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });
    setTabKeyValue(tabKey);
  };

  const getBanks = () => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });
    RequestHandler.get(`/DbsBankInfo/AddedBanks?$select=id,name`).then(
      (response) => {
        setBankSelect({
          data: response,
          loading: false,
        });
      }
    );
  };

  const onChangeBankSelect = (value) => {
    if (value === undefined) {
      setSelectedBankId(null);
    }
    setSelectedBankId(value);
  };

  const onConfirmGetInvoicesFromErp = async () => {
    setGetInvoicesFromErpButtonDisable(true);
    RequestHandler.post(
      "/ErpDbsInvoice/ErpDbsInvoicesAddFromNetsis",
      {},
      false
    ).then((response) => {
      openNotificationGetInvoiceFromErpWithIcon("success");
      setGetInvoicesFromErpButtonDisable(false);
    });
  };

  const onConfirmGetInvoicesFromErpv1 = async () => {
    setGetInvoicesFromErpButtonDisable(true);
    RequestHandler.post(
      "/ErpDbsInvoice/ErpGetDbsInvoicesFromNetsis",
      { dealerCodes: tags, requestDate: selectedDate },
      true
    ).then((response) => {
      setGetInvoicesFromErpButtonDisable(false);
      if (response.success) {
        getTableData();
      }
    });
  };

  const addTag = (val) => {
    if (val.length > 1 && val.length < 21) {
      if (tags.length == 10) {
        countTagError("En fazla 10 adet bayi kodu girebilirsiniz.");
        return;
      }
      setTags([...tags, val]);
    } else {
      countTagError("Girdiğiniz bayi kodu 2-20 karakter arasında olmalıdır.");
    }
  };

  const removeTag = (idx) => {
    var t = [...tags];
    t.splice(idx, 1);
    setTags(t);
  };

  const countTagError = (message) => {
    notification["error"]({
      message: "HATA",
      description: message,
      duration: 4,
    });
  };

  const onChangeSelectDate = (date) => {
    if (date !== null) {
      setSelectedDate(moment(date).format("YYYY-MM-DD"));
    } else {
      setSelectedDate(null);
    }
  };

  const getTenantParameter = () => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        setIsUsePartialDbsInvoice(response.isUsePartialDbsInvoiceAutoSend);
      }
    });
  };

  const partialDbsInvoiceColumns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      width: 150,
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Bayi Adı",
      dataIndex: "dbsDealerName",
    },
    {
      title: "Fatura Tarihi",
      dataIndex: "invoiceDate",
      sorter: true,
      key: "invoiceDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Vade Tarihi",
      dataIndex: "dueDate",
      sorter: true,
      key: "dueDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Fatura Durumu",
      dataIndex: "status",
    },
    {
      title: "Fatura Numarası",
      dataIndex: "invoiceNumber",
    },
    {
      title: "Fatura Tutarı",
      dataIndex: "amount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      dataIndex: "currencyCode",
    },
    {
      title: "Açıklama",
      dataIndex: "description",
    },
    {
      title: "Uyarı",
      dataIndex: "isHaveWarning",
      align: "center",
      render: (data, row) => {
        return data ? (
          <Tooltip title={row.warningMessage}>
            <WarningOutlined style={{ color: "orange", fontSize: "130%" }} />
          </Tooltip>
        ) : undefined;
      },
    },
  ];

  const expendedRowRenderDetail = (data) => {
    return (
      <Table
        columns={partialDbsInvoiceColumns}
        size="small"
        dataSource={data}
        pageable={true}
        pagination={{
          defaultPageSize: 15,
          pageSizeOptions: ["15", "25", "50"],
          total: data.length,
        }}
        rowKey="id"
      />
    );
  };

  return (
    <>
      <Row>
        <Col xs={24} md={8} lg={tabKeyValue === "0" ? 12 : 11}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> FATURA LİSTESİ
          </p>
        </Col>

        <Col
          xs={24}
          md={2}
          lg={6}
          style={{ textAlign: "right" }}
          hidden={tabKeyValue === "1" || tabKeyValue === "2"}
        >
          <Popconfirm
            title="Silmek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmDeleteDbsInvoices}
          >
            <Button
              disabled={selectedRowKeys.length < 1}
              loading={sendInvoiceLoading}
              style={{ marginBottom: 0, marginRight: 15 }}
            >
              <SendOutlined /> Faturaları Sil
            </Button>
          </Popconfirm>
        </Col>

        <Col
          xs={24}
          md={14}
          lg={6}
          style={{ textAlign: "right" }}
          hidden={tabKeyValue === "1" || tabKeyValue === "2"}
        >
          <Popconfirm
            title="Göndermek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmSendInvoice}
          >
            <Button
              disabled={selectedRowKeys.length < 1}
              loading={sendInvoiceLoading}
              style={{ marginBottom: 0, marginRight: 15 }}
            >
              <SendOutlined /> Faturaları Gönder
            </Button>
          </Popconfirm>

          <Button
            type="primary"
            onClick={() => {
              setAddInvoiceVisibility(true);
            }}
            style={{ marginBottom: 0 }}
          >
            <PlusOutlined /> Fatura Ekle
          </Button>
        </Col>

        <Col
          xs={24}
          md={4}
          lg={2}
          style={{ textAlign: "right" }}
          hidden={
            tabKeyValue === "0" ||
            !getErpInvoiceFeatureVisible ||
            tabKeyValue === "2"
          }
        >
          <Popconfirm
            title="Erp'den faturaların çekilmesini istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            onConfirm={onConfirmGetInvoicesFromErp}
          >
            <Button loading={getInvoicesFromErpButtonDisable}>
              <SendOutlined /> Faturaları Çek
            </Button>
          </Popconfirm>
        </Col>
        <Col
          xs={24}
          md={2}
          lg={getErpInvoiceFeatureVisible ? 2 : 4}
          style={{ textAlign: "right" }}
          hidden={tabKeyValue === "0" || tabKeyValue === "2"}
        >
          <Button
            type="primary"
            onClick={() => {
              setVisibleDbsDealerSummaryModal(true);
            }}
            style={{ marginBottom: 0 }}
          >
            <PlusOutlined /> Bayi Not Bilgileri
          </Button>
        </Col>
        <Col
          xs={24}
          md={6}
          lg={4}
          hidden={tabKeyValue === "0" || tabKeyValue === "2"}
          style={{ textAlign: "right" }}
        >
          <Select
            allowClear
            showSearch
            placeholder="Banka Seçiniz"
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
            onChange={(value) => onChangeBankSelect(value)}
            loading={bankSelect.loading}
            style={{ width: "50%" }}
          >
            {bankSelect.data.map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col
          xs={24}
          md={4}
          lg={2}
          style={{ textAlign: "right" }}
          hidden={tabKeyValue === "0" || tabKeyValue === "2"}
        >
          <Popconfirm
            title="Silmek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmDeleteErpDbsInvoices}
          >
            <Button
              disabled={selectedRowKeys.length < 1}
              loading={sendInvoiceLoading}
              style={{ marginBottom: 0, marginRight: 15 }}
            >
              <SendOutlined /> Faturaları Sil
            </Button>
          </Popconfirm>
        </Col>
        <Col
          xs={24}
          md={4}
          lg={3}
          style={{ textAlign: "right" }}
          hidden={tabKeyValue === "0" || tabKeyValue === "2"}
        >
          <Popconfirm
            title="Göndermek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1 || selectedBankId == null}
            onConfirm={onConfirmErpDbsInvoice}
          >
            <Button
              disabled={selectedRowKeys.length < 1 || selectedBankId == null}
              loading={sendInvoiceLoading}
              style={{ marginBottom: 0, marginRight: 15 }}
            >
              <SendOutlined /> Faturaları Oluştur
            </Button>
          </Popconfirm>
        </Col>
      </Row>
      <br></br>
      <Row hidden={tabKeyValue === "0" || tabKeyValue === "2"}>
        <Col xs={24} md={11} lg={11} style={{ textAlign: "right" }}></Col>
        <Col xs={24} md={4} lg={4} style={{ textAlign: "right" }}>
          <DatePicker
            format="DD.MM.YYYY"
            style={{ width: "90%" }}
            onChange={onChangeSelectDate}
            placeholder="Fatura çekimleri için tarih seçin."
          />
        </Col>
        <Col
          xs={24}
          md={6}
          lg={6}
          style={{ textAlign: "right" }}
          hidden={tabKeyValue === "0" || getErpInvoiceFeatureVisible === true}
        >
          <ReactTags
            tags={tags}
            suggestions={suggestions}
            placeholder="Bayi Kodu girin"
            onAddHandler={(val) => addTag(val)}
            onDeleteHandler={(idx) => removeTag(idx)}
          />
        </Col>
        <Col
          xs={24}
          md={3}
          lg={3}
          style={{ textAlign: "right" }}
          hidden={tabKeyValue === "0" || getErpInvoiceFeatureVisible === true}
        >
          <Popconfirm
            title={
              tableData.total > 0 ? (
                <>
                  Listenizde Dbs faturası oluşturulmamış kayıtlar bulunuyor.
                  <br />
                  Bu faturaların üzerine yazılmasına devam etmek istiyor
                  musunuz?
                </>
              ) : (
                "Erp'den faturaların getirilmesini istiyor musunuz?"
              )
            }
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={tags.length == 0 || selectedDate === null}
            onConfirm={onConfirmGetInvoicesFromErpv1}
          >
            <Button
              disabled={tags.length == 0 || selectedDate === null}
              loading={getInvoicesFromErpButtonDisable}
              style={{ marginBottom: 0, marginRight: 15 }}
              type="primary"
            >
              <SendOutlined /> Faturaları Getir
            </Button>
          </Popconfirm>
        </Col>
      </Row>

      {(tabKeyValue === "0" || tabKeyValue === "2") && (
        <DbsInvoiceTableFilter
          onClearFilter={onClearTableFilter}
          onFinishFilter={onFinishTableFilter}
          style={{ marginTop: 12, marginBottom: 12 }}
        />
      )}

      {tabKeyValue === "1" && (
        <ErpDbsInvoiceTableFilter
          onClearFilter={onClearTableFilter}
          onFinishFilter={onFinishTableFilter}
          style={{ marginTop: 12, marginBottom: 12 }}
        />
      )}

      {
        <Row>
          <Col span={20} style={{ textAlign: "end", fontSize: 19 }}>
            <p>Adet : {totalInvoiceCount} </p>
          </Col>
          <Col span={2} style={{ textAlign: "end", fontSize: 19 }}>
            <p>Tutar :</p>
          </Col>
          <Col span={2} style={{ fontSize: 19 }}>
            <CurrencyFormat
              value={parseFloat(invoiceTotalAmount)}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
            />
          </Col>
        </Row>
      }

      <Tabs
        defaultActiveKey={tableDataQueryOptions.activeTab}
        onChange={onTabChange}
        hidden={!isUseErpDbsInvoice && !isUsePartialDbsInvoice}
      >
        <Tabs.TabPane tab="Dbs Faturaları" key="0" />
        {isUseErpDbsInvoice && (
          <Tabs.TabPane
            tab="Erp Dbs Faturaları"
            key="1"
            disabled={!isUseErpDbsInvoice}
          />
        )}

        {isUsePartialDbsInvoice && (
          <Tabs.TabPane
            tab="Parçalı Dbs Faturaları"
            key="2"
            disabled={!isUsePartialDbsInvoice}
          />
        )}
      </Tabs>

      <Row id="tableArea">
        <Col span={24}>
          <Table
            rowSelection={tabKeyValue !== "2" ? rowSelection : undefined}
            columns={
              tabKeyValue === "0"
                ? columns
                : tabKeyValue === "1"
                ? erpDbsInvoiceColumns
                : partialDbsInvoiceColumns
            }
            expandable={
              tabKeyValue === "2" && {
                expandedRowRender: (record) =>
                  expendedRowRenderDetail(record.partialInvoices),
                rowExpandable: (record) => record.partialInvoices !== null,
              }
            }
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
              showSizeChanger: true,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Drawer
        id="addInvoiceDrawer"
        title="Fatura Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddInvoiceVisibility(false)}
        visible={addInvoiceVisibility}
      >
        <DbsInvoiceAddForm onSuccess={onAddInvoiceSuccess} />
      </Drawer>

      <Drawer
        id="updateInvoiceDrawer"
        title="Fatura Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateInvoiceVisibility(false)}
        visible={updateInvoiceVisibility}
      >
        <DbsInvoiceUpdateForm
          data={updateFormData}
          onSuccess={onUpdateInvoiceSuccess}
        />
      </Drawer>

      <Drawer
        id="updateErpDbsInvoiceDrawer"
        title="Erp Fatura Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateErpInvoiceVisibility(false)}
        visible={updateErpInvoiceVisibility}
      >
        <ErpDbsInvoiceUpdateForm
          data={updateFormData}
          onSuccess={onUpdateInvoiceSuccess}
        />
      </Drawer>

      <Drawer
        id="updateMultipleErpDbsInvoiceDrawer"
        title="Çoklu Erp Fatura Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateMultipleErpInvoiceVisibility(false)}
        visible={updateMultipleErpInvoiceVisibility}
      >
        <ErpDbsMultipleInvoiceUpdateForm
          data={updateFormData}
          onSuccess={onUpdateInvoiceSuccess}
        />
      </Drawer>

      <Modal
        id="dbsInvoiceSentWarningModal"
        title={
          <p style={{ marginBottom: 0 }}>
            <WarningOutlined style={{ color: "orange" }} /> Göndermek
            istediğiniz faturaların bir kısmında bayi limit bilgisi güncel
            olmayabilir, bayi limiti aşılmış veya bayide bir hata olabilir.
          </p>
        }
        centered
        visible={sendInvoiceWarningModal.visible}
        onCancel={() => onFinishSendInvoiceWarning()}
        destroyOnClose={true}
        width="95%"
        footer={null}
      >
        <DbsInvoiceSentWarning
          data={sendInvoiceWarningModal.data}
          onFinish={onFinishSendInvoiceWarning}
        />
      </Modal>
      <Modal
        id="dbsInvoiceErpNotAddedSummaryModal"
        title={
          <p style={{ marginBottom: 0 }}>
            <WarningOutlined style={{ color: "orange" }} /> Bayi limitinden veya
            ilgili bayi bulunamadğından veya aynı fatura numarası mevut
            olduğunda eklenemeyen faturalar aşağıda listelenmiştir.Silmek
            istediğiniz faturaları seçerek silebilirsiniz.
          </p>
        }
        centered
        visible={dbsInvoiceErpNotAddedSummaryModalVisible}
        onCancel={() => {
          setDbsInvoiceErpNotAddedSummaryModalVisible(false);
          getTableData();
        }}
        destroyOnClose={true}
        width="95%"
        footer={null}
      >
        <DbsInvoiceErpNotAddedSummary
          data={erpDbsInvoiceModalData}
          bankId={selectedBankId}
        />
      </Modal>
      <Modal
        id="dbsDealerSummaryModal"
        title={
          <p style={{ marginBottom: 0 }}>
            <WarningOutlined style={{ color: "orange" }} /> Bayi Not Bilgileri
          </p>
        }
        centered
        visible={visibleDbsDealerSummaryModal}
        destroyOnClose={true}
        onCancel={() => {
          setVisibleDbsDealerSummaryModal(false);
        }}
        width="80%"
        footer={null}
      >
        <DbsDealerSummary />
      </Modal>
    </>
  );
};

export default DbsInvoice;
